import { render, staticRenderFns } from "./McustomerIndex.vue?vue&type=template&id=f85209c6&scoped=true"
import script from "./McustomerIndex.vue?vue&type=script&lang=js"
export * from "./McustomerIndex.vue?vue&type=script&lang=js"
import style0 from "./McustomerIndex.vue?vue&type=style&index=0&id=f85209c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85209c6",
  null
  
)

export default component.exports